/**
 * @desc getUserCodeByName
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/user/userCodeByName`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
